import {Routes} from '@angular/router';
import {canActivateGuard} from '../../../guards/can-activate-guard';
import {Backend, PERMISSION} from '@generated-backend-types';
import {IndexComponent as OverviewIndexComponent} from './index/index.component';
import RoleEnum = Backend.App.Enums.Auth.RoleEnum;
import {EditComponent as OverviewEditComponent} from './edit/edit.component';
import {TimeTrackingEmployeeService} from '../../../services/api/time-tracking/time-tracking-employee.service';

export const routes: Routes = [
  {
    path: 'month',
    component: OverviewIndexComponent,
    canActivate: [canActivateGuard],
    data: {
      view: 'month',
      anyRoleNeeded: [RoleEnum.TIME_TRACKING_HUMAN_RESOURCES, RoleEnum.TIME_TRACKING_TEAM_LEAD],
      breadcrumb: [
        {
          label: 'authenticated.time_tracking.overview.index.breadcrumb',
          translate: true,
          route: '/time-tracking/overview/month',
        },
      ]
    }
  },
  {
    path: 'year',
    component: OverviewIndexComponent,
    canActivate: [canActivateGuard],
    data: {
      view: 'year',
      anyRoleNeeded: [RoleEnum.TIME_TRACKING_HUMAN_RESOURCES, RoleEnum.TIME_TRACKING_TEAM_LEAD],
      breadcrumb: [
        {
          label: 'authenticated.time_tracking.overview.index.breadcrumb',
          translate: true,
          route: '/time-tracking/overview/year',
        },
      ]
    }
  },
  {
    path: ':id',
    component: OverviewEditComponent,
    canActivate: [canActivateGuard],
    resolve: {
      timeTrackingEmployee: TimeTrackingEmployeeService,
    },
    data: {
      allPermissionsNeeded: [PERMISSION.TIMETRACKING_TIMETRACKINGOVERVIEW_TIMETRACKINGOVERVIEWBYMONTHVIEW_READ_ALL],
      breadcrumb: [
        {
          label: 'authenticated.time_tracking.overview.index.breadcrumb',
          translate: true,
          route: '/time-tracking/overview/month',
        },
        {dynamic: true, dataKey: 'timeTrackingEmployee.user.name', route: '/time-tracking/overview/:id'},
        {label: 'authenticated.time_tracking.overview.edit.breadcrumb', translate: true,},
      ]
    }
  },
  {
    path: '**',
    redirectTo: 'month'
  }
];
